import { CookieLoginResponse } from '../../shared/models'
import axios from 'axios'

function getCsrfToken(): string | null {
    const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : null
}

export class LoginApi {
    public static login(email: string, password: string) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVER_LOCATION,
            withCredentials: true,
        })

        return instance
            .post<CookieLoginResponse>(
                'api/auth/login',
                { userName: email, password },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            .then(r => r.data)
    }

    public static logout() {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_SERVER_LOCATION,
            withCredentials: true,
        })

        const csrfToken = getCsrfToken()

        return instance.post(
            'api/auth/logout',
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken || '',
                },
            }
        )
    }
}
